import { render, staticRenderFns } from "./EditorReadonly.vue?vue&type=template&id=84ac31d2&scoped=true&"
import script from "./EditorReadonly.vue?vue&type=script&lang=ts&"
export * from "./EditorReadonly.vue?vue&type=script&lang=ts&"
import style0 from "./EditorReadonly.vue?vue&type=style&index=0&id=84ac31d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ac31d2",
  null
  
)

export default component.exports